import { render, staticRenderFns } from "./modalAsignarOperadorTablero.vue?vue&type=template&id=4854d7ae&"
import script from "./modalAsignarOperadorTablero.vue?vue&type=script&lang=js&"
export * from "./modalAsignarOperadorTablero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports